<template>
  <el-dialog
    class="dialog-wrapper thermostats-modal"
    visible
    :show-close="false"
    @close="abortCreate"
  >
    <ContentHeader
      slot="title"
      :title="
        isModalEdit
          ? $t('thermostats.update.title')
          : $t('thermostats.create.title')
      "
    />
    <ValidationObserver
      ref="roleForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row
          :gutter="20"
          type="flex"
        >
          <el-col :span="18">
            <FormItem
              rules="required"
              :label="$t('thermostats.create.name')"
            >
              <el-input v-model="formData.name" />
            </FormItem>
          </el-col>
          <el-col :span="6">
            <FormItem
              rules="required"
              :label="$t('thermostats.create.enabled')"
            >
              <el-switch
                v-model="formData.enabled"
                :active-text="$t('thermostats.create.enabled')"
              >
              </el-switch>
            </FormItem>
          </el-col>
        </el-row>

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortCreate"
          >
            {{ $t('thermostats.create.abortCreate') }}
          </el-button>
          <el-button
            v-if="isModalEdit"
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(updateThermostat)"
          >
            {{ $t('thermostats.update.updateThermostat') }}
          </el-button>
          <el-button
            v-else
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(createThermostat)"
          >
            {{ $t('thermostats.create.createThermostat') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { thermostatsApi } from '@/api';
  import FormItem from '@/components/FormItem.vue';
  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';

  const defaultData = {
    name: '',
    enabled: true,
  };

  export default {
    name: 'CreateEditRole',
    components: {
      FormItem,
      ContentHeader,
      FormButtons,
    },
    props: {
      isModalEdit: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...defaultData },
      };
    },
    created() {
      if (this.$route.params.thermostatId) this.getThermostat();
    },
    methods: {
      async getThermostat() {
        try {
          const response = await thermostatsApi.show(
            this.$route.params.thermostatId
          );
          this.formData = {
            name: response.data.name,
            enabled: response.data.enabled,
          };
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async createThermostat() {
        try {
          await thermostatsApi.create(this.formData);
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('thermostats.create.success'),
          });
          this.$emit('dialogClose', { success: true });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async updateThermostat() {
        try {
          await thermostatsApi.patch(
            this.$route.params.thermostatId,
            this.formData
          );
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('thermostats.update.success'),
          });
          this.$emit('dialogClose', { success: true });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      abortCreate() {
        this.$emit('dialogClose', { success: false });
      },
    },
  };
</script>
